import React from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import ModalWrapper from 'components/ModalWrapper'
import Nixi1Spinner from 'components/Nixi1Spinner'
import './styles.scss'
import usePluginLabels from './usePluginLabels'
import TagSelector from 'components/TagSelector'

const PluginLabels = ({ data: { user } }) => {
  const {
    isOpenModalIsFolder, setIsOpenModalIsFolder, isOpen, isLoading,
    setIsOpen, inRequest, categories, allCategories, addRecord,
    removeRecord, searchCategory, subjectId, getTypeAndId,
  } = usePluginLabels({ user })
  return (
    <div className='plugin-categories'>
      <div
        className='plugin-categories__header'
        onClick={() => setIsOpen(!isOpen)}
      >
        <div
          className={`
            plugin-categories__add-category
            ${!subjectId && !['subject', 'user'].includes( getTypeAndId().type) ? 'plugin-categories__add-category--disabled' : ''}
          `}
        >
          <figure className='plugin-categories__header-icon'>
            <img
              src={getStaticImage('/icons/orange-brand/icon-label-dark.svg')}
              alt={I18n.t('dashboard_labels')}
            />
          </figure>
          <span>{I18n.t('dashboard_labels')}</span>
          {inRequest ? (
            <div style={{ marginLeft: 5 }}>
              <Nixi1Spinner height='18px' width='18px'/>
            </div>
          ) : null}
        </div>
        <button className='plugin-categories__add-btn'>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-plus-dark.svg')} alt='Add category' />
          </figure>
        </button>
      </div>

      {categories.length > 0 ? (
        <div className='plugin-categories__list--added'>
          {categories.length > 0 && categories.map(e => (
            <div
              key={e.category}
              className='plugin-categories__category-item plugin-categories__category-item--added animated fadeIn'
              style={{ 'backgroundColor': e.color ? e.color : '#f9f6f6', color: e.color ? 'white' : 'black' }}
              onClick={()=>e.isFolder ? setIsOpenModalIsFolder(true) : undefined}
            >
              <span>
                {e.type
                  ? I18n.t(`dashboard_${e.type}`)
                  : e.name
                }
              </span>
              {!e.isFolder && <i className='fa fa-times' onClick={() => removeRecord(e)}></i>}
              {e.isFolder && <img src={getStaticImage('/channels/orange-brand/chatmail-icon.svg')} alt="chatmail" />}
            </div>
          ))}
        </div>
      ) : null}

      <TagSelector 
        hasCreateCategoryOption
        onCategoryClick={addRecord}
        allCategories={allCategories}
        searchCategory={searchCategory}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        selectedCategories={allCategories.filter(e => e.added).map(e => e.category)}
        isLoading={isLoading}
      />

      <ModalWrapper
        isOpen={isOpenModalIsFolder}
        toggle={() => setIsOpenModalIsFolder(!isOpenModalIsFolder)}
        body={
          <p
            dangerouslySetInnerHTML={{
              __html: I18n.t('categories_remove_folder')
            }}
          ></p>
        }
        eventBtnTxt={I18n.t('dashboard_accept')}
        eventBtn={() => setIsOpenModalIsFolder(!isOpenModalIsFolder)}
      />
    </div>

  )
}

export default PluginLabels
